module.exports = __webpack_public_path__ + "assets/arrow-right.15f9054b.svg";